import {Button, Table, Typography, Form, Space, Row, message} from "antd";
import React, { SetStateAction, useEffect, useState } from "react";
import { EditableCell, EditableRow } from "./EditTable";
import Icons from "assets/icons";
import { ColumnTypes } from "types/models/column-table-edit";
import "./TableInputAdd.scss";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {employeeService} from "api"
import Notification from "../../../../../../../components/common/notification/notification";
import { SpinProps } from "antd/lib/spin";
import { setLoading } from 'redux/reducer/medicineStore';
interface TableInputAddProps {
  id:any;
  data: any;
  column: any;
  setData: any;
  pagination?: boolean | any;
  loading?: boolean | SpinProps;
  scroll?: any;
  onRow?: any;
  rest?: any;
  isCheckbox?: boolean;
  rowSelection?: any;
  disabled?: boolean;
  count: any;
  setCount: any;
}
const TableInputAdd = ({
  id,
  data,
  column,
  setData,
  isCheckbox,
  disabled,
  count,
  setCount,
  ...rest
}:TableInputAddProps): JSX.Element => {
  const dispatch = useAppDispatch(); 
  const detailRecord = useAppSelector(
    (state) => state.pharmacyStore.detailRecord
  );
  const selectedRecord = useAppSelector(
    (state) => state.pharmacyStore.selectedRecord
  );
  const [form] = Form.useForm();

  const addRowTb1 = () => {
    const newData = {
      key: count,    
      // key: data.length,
      ...column.reduce((obj, col) => {
       
        if (col.dataIndex !== "idNhanVien" && obj) {
          if (col.selected) {
            obj[col.placeholder] = "Chọn";
          } else {
            obj[col.placeholder] = "Nhập";
          }
        }
      }),
    };

    setData([...data, newData]);
    setCount(count+1);
  };

  column.some((item) => {
    if (item.key == "action") {
      item.title = (
        <Button
          disabled={disabled}
          type="primary"
          onClick={addRowTb1}
          icon={<Icons.add  />}
          size="small"
        />
      );
      item.render = (_, record: { key: React.Key }, index) => (
        <Button
          disabled={disabled}
          type="primary"
          danger
          onClick={() => removeRowTb1(index , record?.key)}
          icon={<Icons.sub  />}
          size="small"
        />
        
      );
    }

  });

  const removeRowTb1 = (indexRemove , record) => {
    const newData = data.filter((e, index) => index != indexRemove);
    //deleteTraningNV(record.id)
    setData([...newData]);
  };
  const deleteTraningNV = async (id) => {
    // try {
    //   const res = await employeeService.deleteTraningNV(id);
    //   Notification("success","Đã xóa dữ liệu vừa chọn");
    // } catch (error) {
    //   Notification("error","Đã xảy ra lỗi khi xóa dữ liệu");
    // }
  };

  const handleSave = (row, index) => {
    const newData = [...data];

    newData[index] = row;
    setData(newData);
    setCount(count+1);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const columns = column
    .filter((e) => e.show == true)
    .map((col) => {
      return {
        ...col,
        onCell: (record, index) => ({
          id:id,
          record: data[index],
          selected: col.selected,
          dataIndex: col.dataIndex,
          title: col.title,
          options: col.options,
          onChange: col.onChange,
          index: index,
          handleSave,
          type: col.type,
          disabled: disabled ?? col.disabled,
          value: col.value,
          name: col.name,
          rules: col.rules,
          autoFocus: col.autoFocus,
          // ...col,
        }),
      };
    });

  useEffect(() => {}, [data]);
  return (
    <>
      <Table
        className="table-prescription"
        components={components}
        rowClassName={"editable-row-2"}
        bordered
        dataSource={[...data]}
        columns={columns as ColumnTypes}
        {...rest}
      />
      {/* {data && columnsInit && components && (
        <Form form={form}>
          <Form.Item name={"table"}></Form.Item>
        </Form>
      )} */}
    </>
  );
};

export default TableInputAdd;
